import type { CompanyImagesModel } from "../../../../viewjobOneGraphModel";

import { Box } from "../../../../../../mads";
import { Banner } from "../Banner";
import { Logo } from "../Logo";

import React from "react";
import { StyleSheet } from "react-native";

interface FullScreenHeaderProps {
  companyImagesModel?: CompanyImagesModel | null;
}

export const LogoBannerFlair = ({ companyImagesModel }: FullScreenHeaderProps) => {
  if (!companyImagesModel) {
    return null;
  }

  if (!companyImagesModel.showBannerTop) {
    return null;
  }

  return (
    <>
      {companyImagesModel.headerImageUrl && (
        <Banner url={companyImagesModel.headerImageUrl} altText={companyImagesModel.logoAltText} />
      )}

      <Box
        sx={
          companyImagesModel.logoUrl && companyImagesModel.headerImageUrl
            ? styles.logoBannerContainer
            : styles.logoContainer
        }
      >
        {companyImagesModel.logoUrl && (
          <Logo
            url={companyImagesModel.logoUrl}
            altText={companyImagesModel.logoAltText}
            size={64}
            hasShadow={false}
            hasBorder={true}
          />
        )}
      </Box>
    </>
  );
};

const styles = StyleSheet.create({
  logoBannerContainer: {
    flexDirection: "row",
    paddingLeft: 16,
    bottom: 32,
    gap: 12,
    marginBottom: -20,
  },
  logoContainer: {
    flexDirection: "row",
    paddingLeft: 16,
    marginTop: 12,
    bottom: 4,
    gap: 12,
    marginBottom: -4,
  },
});
